import { render, staticRenderFns } from "./EmployersRow.vue?vue&type=template&id=ce5dfaf4&"
import script from "./EmployersRow.vue?vue&type=script&lang=js&"
export * from "./EmployersRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports